var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSalesrep(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-user-cog w-5 h-5 flex-shrink-0",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 15H6a4 4 0 0 0-4 4v2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m14.305 16.53.923-.382"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m15.228 13.852-.923-.383"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m16.852 12.228-.383-.923"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m16.852 17.772-.383.924"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m19.148 12.228.383-.923"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m19.53 18.696-.382-.924"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m20.772 13.852.924-.383"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m20.772 16.148.924.383"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 15,
    r: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 7,
    r: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesrep);
export default __webpack_public_path__ + "static/media/salesrep.5401881b7f826f9ec406008a801c0993.svg";
export { ForwardRef as ReactComponent };